import React, { useState } from 'react';
import ConstructionPage from './components/ConstructionPage';

const App = () => {
  const [page, setPage] = useState('construction'); // Solo hay una página por ahora

  return (
    <div className="App">
      {page === 'construction' && <ConstructionPage setPage={setPage} />}
    </div>
  );
};

export default App;

// DONE